module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_6.9897b889.png";